import http from "@/http/aisea/axios";
const resource = "/port_master/enterprises/ports";

export default {
  add(portId, payload) {
    return http.post(`${resource}/${portId}/tasks`, payload);
  },

  bulks(portId, payload) {
    return http.post(`${resource}/${portId}/tasks/bulks`, payload);
  },

  import(portId, file) {
    let formData = new FormData();
    formData.append("excel", file);
    return http.post(`${resource}/${portId}/tasks/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });
  },

  export(portId, date) {
    return http.post(`${resource}/${portId}/tasks/export/${date}`, null, {
      responseType: "blob",
    });
  },

  download(portId, date) {
    return http.post(`${resource}/${portId}/tasks/download/${date}`, null, {
      responseType: "blob",
    });
  },
};
